export const headerQuery = `{
  pageHeaderFooterNavMenu(id: "${process.env.REACT_APP_PAGE_HEADER_FOOTER_ID}") {
      logo {
        url
        icon {
          url
        }
      } 
      navLinksCollection{
        items {
          text
          url
          itemsCollection{
            items {
              text
              url
            }
          }
        }
      }
      arrowsIcon {
        url
      }
      nav {
        url
      }
      closeIcon {
        url
      }
    }
  }`

export function headerParser(CMSData) {
  if (CMSData == undefined) {
    return { error: "Internal error" }
  } else {
    return {
      logo: {
        url: CMSData.pageHeaderFooterNavMenu.logo.url,
        icon: CMSData.pageHeaderFooterNavMenu.logo.icon.url,
      },
      navLinks: CMSData.pageHeaderFooterNavMenu.navLinksCollection.items.map(
        navLink => ({
          text: navLink.text,
          url: navLink.url,
          items: navLink.itemsCollection.items
            ? navLink.itemsCollection.items.map(item => ({
                text: item.text,
                url: item.url,
              }))
            : [],
        })
      ),
      arrowsIcon: CMSData.pageHeaderFooterNavMenu.arrowsIcon.url,
      menu: CMSData.pageHeaderFooterNavMenu.nav.url,
      closeIcon: CMSData.pageHeaderFooterNavMenu.closeIcon.url,
    }
  }
}
